// @core/api/endpoints/billing/get_billing_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBillingAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get billing account by ID
 * Retrieves a billing account by its unique identifier. Returns account details, payment settings, and current balance information.
 */
export async function GetBillingAccount(
  id: string,
  options?: RequestOptions
): Promise<GetBillingAccountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetBillingAccountResponse>(requestPath, { ...requestOptions });
}
